//import Vue from 'vue'
//import {request} from "express";
//import { axios } from '@/utils/request'
//import axios from 'axios';
import { axios } from '@/utils/request'
import config from '@/config'  // 引入配置文件
let apiBaseUrl = config.apiBaseUrl;
//import { axios } from '@/utils/request'
// const api = {
//   user: '/mock/api/user',
//   role: '/mock/api/role',
//   service: '/mock/api/service',
//   permission: '/mock/api/permission',
//   permissionNoPager: '/mock/api/permission/no-pager',
// }
//import {request} from "express";
//let apiBaseUrl = "http://47.92.113.172:9090/jeecg-boot";
//let apiBaseUrl = "http://zcics.sdnu.edu.cn:3014/jeecg-boot";
//let apiBaseUrl = "http://zcics.sdnu.edu.cn:3002/gxnnk";
//let apiBaseUrl = "http://127.0.0.1:8081/gxnnk";
export function baseUrl() {
  return apiBaseUrl;
}
export function getAction (url, parameter) {
  return axios({
    url: apiBaseUrl+url,
    method: 'get',
    params: parameter
  })
}
//post
export function postAction(url,parameter) {
  return axios({
    url: apiBaseUrl+url,
    method:'post' ,
    data: parameter
  })
}

//post method= {post | put}
export function httpAction(url,parameter,method) {
  return axios({
    url: apiBaseUrl+url,
    method:method ,
    data: parameter
  })
}

